import React, { useContext } from 'react';
import CreateAccount from './CreateAccount';
import OrderConfirmationContext from '../../../context/OrderConfirmationContext';

export default function CreateAccountWrapper() {
  const { orderConfirmationData } = useContext(OrderConfirmationContext);
  const {
    textFor, orderContact,
  } = orderConfirmationData;

  const {
    buttonSubmit,
  } = textFor;

  // No mutation, no processing, just show the same message and button
  return (
    <CreateAccount
      email={orderContact.email}
      buttonSubmitLabel={buttonSubmit}
    />
  );
}
